import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '@/utils/routes/routes';

const UnAuthRoute = ({ children }: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem('token');
    const isAuthPath =
      location.pathname.includes('login') ||
      location.pathname.includes('register') ||
      location.pathname.includes('forgot-password') ||
      location.pathname.includes('reset-password');

    if (auth && isAuthPath) {
      navigate(routes.home, { replace: true });
    }
  }, [location?.pathname]);

  return children;
};

export default UnAuthRoute;
